import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class CertificationAssigneeCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showAll: props.showAll
        };
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentWillReceiveProps(nextProps) {
        if (this.state.showAll === nextProps.showAll)
            return;
            
        this.setState({
            showAll: nextProps.showAll
        }, this.loadAssignee);
    }

    loadAssignee = () => {
        let rq = {
            showAll: this.state.showAll
        };

        API.Admin.get('/queue/getAssigneeUsers', rq,
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.fullName, value: item.userId } })
                    });
                }
            }, { block: false });
    }

    componentDidMount = () => {
        this._isMounted = true;
        this.loadAssignee();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Assignee"}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default CertificationAssigneeCombo;

// Mark this as a form component
CertificationAssigneeCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/certificationAssigneeCombo/CertificationAssigneeCombo.js